import { Checkbox, DatePicker, Select, Typography } from 'antd';
import moment from 'moment';
import { IBestDataset } from '../../../../../../types/analytics';
import { DateFormat } from '../../../../../../utils/StaticVariable';
import styles from '../../Layout/AnalyticsLayout.module.scss';

const { Text } = Typography;

interface HistogramInputFormProps {
  datasets: IBestDataset[];
  dataset: string;
  onSelectDataset: (value: string) => void;
  categories: string[];
  variablesX: any[];
  variableX: any;
  onVariableXChange: (value: any) => void;
  startDate: moment.Moment;
  endDate: moment.Moment;
  onStartDateChange: (date: any) => void;
  onEndDateChange: (date: any) => void;
  disabledStartDate: (date: any) => boolean;
  disabledEndDate: (date: any) => boolean;
  isForAllAnalytics: boolean;
  onCheckboxChange: () => void;
  isLoading: boolean;
  isOfflineDataset: boolean;
}

export default function HistogramInputForm({
  datasets,
  dataset,
  onSelectDataset,
  categories,
  variablesX,
  variableX,
  onVariableXChange,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  disabledStartDate,
  disabledEndDate,
  isForAllAnalytics,
  onCheckboxChange,
  isOfflineDataset,
  isLoading,
}: HistogramInputFormProps) {
  return (
    <div className={styles.formRow}>
      <div className={`${styles.formItem} ${styles.datasetItem}`}>
        <Text>Dataset</Text>
        <Select
          id='Analytics-Histogram-Dataset_Input'
          value={dataset}
          onChange={onSelectDataset}
          placeholder='Select dataset'
          disabled={isLoading}
        >
          {categories.map((category: string) => (
            <Select.OptGroup key={category} label={category}>
              {datasets
                .filter((item) => item.label === category)
                .map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.value}
                  </Select.Option>
                ))}
            </Select.OptGroup>
          ))}
        </Select>
      </div>

      <div className={`${styles.formItem} ${styles.variableItem}`}>
        <Text>Variable X (Magnitude)</Text>
        <Select
          id='Analytics-Histogram-Variable_Input'
          placeholder='Select variable'
          onChange={onVariableXChange}
          value={variableX?.Index ? variableX.Index : 0}
          disabled={isOfflineDataset || isLoading}
        >
          {variablesX
            .filter((item) => item.Name !== 'Time')
            .map((item) => (
              <Select.Option key={item.Index} value={item.Index}>
                {item.Name}
              </Select.Option>
            ))}
        </Select>
      </div>

      <div
        className={`${styles.formItem} ${styles.dateItem}`}
        data-testid='Analytics-StartDate_Input'
      >
        <Text>Start Date</Text>
        <DatePicker
          // id='Analytics-Histogram-StartDate_Input'
          value={moment(startDate)}
          disabledDate={disabledStartDate}
          onChange={onStartDateChange}
          format={DateFormat}
          disabled={isOfflineDataset || isLoading}
        />
      </div>

      <div
        className={`${styles.formItem} ${styles.dateItem}`}
        data-testid='Analytics-EndDate_Input'
      >
        <Text>End Date</Text>
        <DatePicker
          // id='Analytics-Histogram-EndDate_Input'
          value={moment(endDate)}
          disabledDate={disabledEndDate}
          onChange={onEndDateChange}
          format={DateFormat}
          disabled={isOfflineDataset || isLoading}
        />
      </div>

      <div
        className={`${styles.formItem} ${styles.checkboxItem}`}
        data-testid='Analytics-Period-Checkbox'
      >
        <Checkbox
          disabled={isOfflineDataset || isLoading}
          checked={isForAllAnalytics}
          onChange={onCheckboxChange}
        />
        <Text onClick={onCheckboxChange} style={{ cursor: 'pointer' }}>
          Use this period for all analytics
        </Text>
      </div>
    </div>
  );
}
